var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"event-view"},[_c('div',{staticClass:"header"},[_vm._v("YOUR EVENTS")]),_c('events-overview')],1)}
var staticRenderFns = []

export { render, staticRenderFns }